<template>
  <WsRead
    titleKey="name"
    :label="label"
    :fields="fields"
    :localeMode="true"
    :showExpand="false"
    :isMultiSelect="true"
    :modelName="modelName"
    :id="$route.params.id"
    :showFields="showFields"
    :primary="_pageSetting.primary"
    :secondary="_pageSetting.secondary"
    :staticModelData="staticModelData"
    @input="$_getModelData($event)"
  >
  </WsRead>
</template>

<script>
import model from "@/models/role_type";
import subModel from "@/models/role";
export default {
  data(){
    return {
      modelData: {},
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      showFields: ["name"],
      staticModelData: (modelData, fields) => {
        subModel.scopeFields.forEach(scope => {
          if (fields[scope].items.length) {
            fields[scope].items.forEach(valueItem => {
              let result = true;
              if (valueItem.value) {
                valueItem.value.forEach(item => {
                  if (result) result = modelData.scopes.includes(item);
                });
                if (result) {
                  modelData[scope] = [
                    ...(modelData[scope] || []),
                    ...valueItem.value,
                  ];
                }
              }
            });
          }
        });
      },
    }
  },
  computed: {
    _pageSetting() {
      const roleHasScopeValueList = this.modelData?.scopes;
      const roleHasRoleList = roleHasScopeValueList
        ? subModel.scopeFields.filter(scope => {
            let isHasScope = false;
            for (let valueItem of this.fields[scope].items) {
              for (let _value of valueItem.value) {
                if (roleHasScopeValueList.includes(_value)) isHasScope = true;
              }
            }
            return isHasScope;
        })
        : [];
      return {
        primary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "角色類型資訊",
                fields: ["locales", "sequence"],
              },
              {
                title: "權限列表",
                fields: roleHasRoleList,
              },
            ],
          },
        ],
        secondary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "前台是否需要設定限閱領域",
                type: "switch",
                fields: ["has_factory_system"],
              },
              {
                title: "前台是否需要設定限閱轄下單位",
                type: "switch",
                fields: ["has_factory_scope"],
              },
            ],
          },
          {
            type: "infoCard",
            floors: [
              {
                title: "建立資訊",
                fields: ["created_admin", "created_at"],
              },
            ],
          },
          {
            type: "infoCard",
            floors: [
              {
                title: "編輯資訊",
                fields: ["updated_admin", "updated_at"],
              },
            ],
          },
        ],
      };
    }
  },
  methods: {
    $_getModelData($event) {
      this.modelData = $event;
    }
  }
};
</script>